export default __webpack_public_path__ + "static/media/pair@2x.579fea42.png";